export default __webpack_public_path__ + "static/media/challenge.07bb1181.png";